import React from "react";

const CONVERTERS = [
  { name: "json-to-xml", label: "JSON → XML" },
  { name: "xml-to-json", label: "XML → JSON" },
  { name: "json-to-yml", label: "JSON → YAML" },
  { name: "yml-to-json", label: "YAML → JSON" },
  { name: "js-to-jsx", label: "JS → JSX" },
];

const RESOURCES = [
  { href: "/about", label: "About" },
  { href: "/about", label: "Keyboard shortcuts" },
  { href: "/privacy", label: "Privacy" },
];

export default function Footer({ entries = {} }) {
  return (
    <footer className="site-footer">
      <div className="footer-top">
        <div className="footer-brand">
          <span className="logo">{`<${window.SITE_NAME}/>`}</span>
          <p>
            A quiet, browser-based workspace for formatting and converting code
            &amp; data.
          </p>
        </div>

        <div className="footer-col">
          <h3>Formatters</h3>
          {Object.entries(entries).map(([key, label]) => (
            <a key={key} href={`/formatter/${key}`}>
              {label}
            </a>
          ))}
        </div>

        <div className="footer-col">
          <h3>Converters</h3>
          {CONVERTERS.map((c) => (
            <a key={c.name} href={`/converter/${c.name}`}>
              {c.label}
            </a>
          ))}
        </div>

        <div className="footer-col">
          <h3>Resources</h3>
          {RESOURCES.map((r, i) => (
            <a key={i} href={r.href}>
              {r.label}
            </a>
          ))}
        </div>
      </div>

      <div className="footer-bottom">
        <span>© 2026 {window.SITE_NAME}. Built for engineers.</span>
        <span className="footer-tags">all-local · no telemetry</span>
      </div>
    </footer>
  );
}
